/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckRevertBedSwapEligibility200ResponseData
 */
export interface CheckRevertBedSwapEligibility200ResponseData {
    /**
     * Whether the bed swap can be reverted
     * @type {boolean}
     * @memberof CheckRevertBedSwapEligibility200ResponseData
     */
    can_revert?: boolean;
    /**
     * Date when the bed swap occurred (present when can_revert is true)
     * @type {string}
     * @memberof CheckRevertBedSwapEligibility200ResponseData
     */
    swap_date?: string;
    /**
     * ID of the other lead involved in the swap (present when can_revert is true)
     * @type {string}
     * @memberof CheckRevertBedSwapEligibility200ResponseData
     */
    swapped_with_lead_id?: string;
    /**
     * Name of the other lead involved in the swap (present when can_revert is true)
     * @type {string}
     * @memberof CheckRevertBedSwapEligibility200ResponseData
     */
    swapped_with_lead_name?: string;
    /**
     * Name of the current bed (present when can_revert is true)
     * @type {string}
     * @memberof CheckRevertBedSwapEligibility200ResponseData
     */
    current_bed_name?: string;
    /**
     * Name of the original bed before swap (present when can_revert is true)
     * @type {string}
     * @memberof CheckRevertBedSwapEligibility200ResponseData
     */
    original_bed_name?: string;
    /**
     * Name of the other resident's current bed (present when can_revert is true)
     * @type {string}
     * @memberof CheckRevertBedSwapEligibility200ResponseData
     */
    other_resident_current_bed_name?: string;
    /**
     * Name of the other resident's original bed (present when can_revert is true)
     * @type {string}
     * @memberof CheckRevertBedSwapEligibility200ResponseData
     */
    other_resident_original_bed_name?: string;
    /**
     * Reason why the swap cannot be reverted (present when can_revert is false)
     * @type {string}
     * @memberof CheckRevertBedSwapEligibility200ResponseData
     */
    reason?: string;
}

/**
 * Check if a given object implements the CheckRevertBedSwapEligibility200ResponseData interface.
 */
export function instanceOfCheckRevertBedSwapEligibility200ResponseData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CheckRevertBedSwapEligibility200ResponseDataFromJSON(json: any): CheckRevertBedSwapEligibility200ResponseData {
    return CheckRevertBedSwapEligibility200ResponseDataFromJSONTyped(json, false);
}

export function CheckRevertBedSwapEligibility200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckRevertBedSwapEligibility200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'can_revert': !exists(json, 'can_revert') ? undefined : json['can_revert'],
        'swap_date': !exists(json, 'swap_date') ? undefined : json['swap_date'],
        'swapped_with_lead_id': !exists(json, 'swapped_with_lead_id') ? undefined : json['swapped_with_lead_id'],
        'swapped_with_lead_name': !exists(json, 'swapped_with_lead_name') ? undefined : json['swapped_with_lead_name'],
        'current_bed_name': !exists(json, 'current_bed_name') ? undefined : json['current_bed_name'],
        'original_bed_name': !exists(json, 'original_bed_name') ? undefined : json['original_bed_name'],
        'other_resident_current_bed_name': !exists(json, 'other_resident_current_bed_name') ? undefined : json['other_resident_current_bed_name'],
        'other_resident_original_bed_name': !exists(json, 'other_resident_original_bed_name') ? undefined : json['other_resident_original_bed_name'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function CheckRevertBedSwapEligibility200ResponseDataToJSON(value?: CheckRevertBedSwapEligibility200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'can_revert': value.can_revert,
        'swap_date': value.swap_date,
        'swapped_with_lead_id': value.swapped_with_lead_id,
        'swapped_with_lead_name': value.swapped_with_lead_name,
        'current_bed_name': value.current_bed_name,
        'original_bed_name': value.original_bed_name,
        'other_resident_current_bed_name': value.other_resident_current_bed_name,
        'other_resident_original_bed_name': value.other_resident_original_bed_name,
        'reason': value.reason,
    };
}

